import React, { createContext, useState, useContext } from 'react';
import { login as loginService } from '../services/api'; // Lo crearemos pronto
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('authToken'));
  const navigate = useNavigate();

  const login = async (username, password) => {
    try {
      const response = await loginService(username, password);
      const authToken = response.data.access;
      setToken(authToken);
      localStorage.setItem('authToken', authToken);
      navigate('/dashboard'); // Redirige al dashboard después del login
    } catch (error) {
      console.error("Error en el login", error);
      alert("Usuario o contraseña incorrectos.");
    }
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem('authToken');
    navigate('/login'); // Redirige al login
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook personalizado para usar el contexto fácilmente
export const useAuth = () => {
  return useContext(AuthContext);
};